module.exports = __webpack_public_path__ + "img/recordStop.115ab3e3.png";